<template>

  <div v-if="filled">
    <div class="card-header">
      <i
        v-if="!editable && editMode"
        class="fas fa-pencil-alt"
        :title="$t('Edit')"
        @click.stop="editSection(true)"
        style="cursor: pointer; float: right;">
        </i>
      <strong>Data de contratação</strong>
    </div>
    <div
      v-if="editable"
      class="card-body">
      <form v-on:submit.prevent="save(placementEdit)">
        <div class="form-group">
          <date 
            :setting="{format: 'DD-MM-YYYY'}"
            v-model="placementEdit.hired_date">
            </date>
          <ValidateMessage :error="validateErrors.hired_date" />
        </div>
        <div :class="{'box-loading': loading}">
          <button
            type="submit"
            class="btn btn-primary">
            {{ $t('Save') }}
            </button>
          <button
            type="button"
            class="btn btn-light"
            @click.stop="editSection(false)">
            {{ $t('Cancel') }}
            </button>
        </div>
      </form>
    </div>
    <div
      v-if="!editable && filled"
      class="card-body">
      {{ $d(new Date(placement.hired_date), 'short') }}
    </div>
  </div>

</template>

<script>
import _ from 'lodash'
import Date from '@/components/Fields/Date'

export default {
  name: 'CandidateProfileHired',
  components: {
    Date
  },
  props: [
    'editMode'
  ],
  data () {
    return {
      loading: false,
      sectionEdit: false,
      placementEdit: {},
      validateErrors: false
    }
  },
  created () {
  },
  computed: {
    editable () {
      return this.sectionEdit && this.editMode
    },
    candidateJobId () {
      return this.$route.query.candidate_job_id
    },
    candidate () {
      return this.$store.getters.getCandidate
    },
    placement () {
      if (!this.candidateJobId) return null
      return this.candidate.placements.find((placement) => {
        return placement.job_id === this.candidateJobId
      })
    },
    filled () {
      return this.placement && this.placement.hired && this.placement.hired_date
    }
  },
  methods: {
    editSection (status) {
      this.sectionEdit = status
      this.placementEdit = _.pick(this.placement, [
        '_id',
        'hired_date'
      ])
    },
    save (data) {
      this.loading = true

      this.$store
      .dispatch('updatePlacement', {
        _id: data._id,
        hired_date: data.hired_date
      })
      .then((response) => {
        this.loading = false
        this.sectionEdit = false
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Profile/CandidateProfileHired.vue